import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'formik';
import { InputGroup, InputFeedback, AsyncSelect } from '@components/common';
import API from '@utils/api';
import logger from '@utils/logger';
import PropertyOption from './PropertyOption';
import PropertyValue from './PropertyValue';
import PropertyNoOption from './PropertyNoOption';

function PropertyField(props) {
  const [propertyOptions, setPropertyOptions] = useState(true);

  const searchProperties = async property => {
    if (!property) {
      return [];
    }
    try {
      const { result } = await API.getProperties(property);
      const { properties } = result;

      const convertedProperties = properties.map(item => {
        const bedroomsCounts = (item.bedroomsCounts || []).slice(0);
        bedroomsCounts.sort((a, b) => a - b);

        return {
          ...item,
          bedroomsCounts
        };
      });
      setPropertyOptions(convertedProperties);
      return convertedProperties;
    } catch (err) {
      logger.error(err);
    }

    return [];
  };
  const { field, label, form, allowRequestProperty, mb, ...rest } = props;
  const formError = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const hasError = !!(touched && formError);

  return (
    <InputGroup mb={mb}>
      <AsyncSelect
        disabled={form.isSubmitting}
        {...rest}
        placeholder={label}
        value={field.value}
        isClearable
        onChange={val => {
          form.setFieldValue(field.name, val);
          form.setFieldValue('bedroomsCount', '');
          form.setFieldValue('buildingName', '');
          form.setFieldValue('unitNumber', '');
        }}
        components={
          allowRequestProperty
            ? {
                Option: PropertyOption,
                SingleValue: PropertyValue,
                NoOptionsMessage: PropertyNoOption
              }
            : {
                Option: PropertyOption,
                SingleValue: PropertyValue
              }
        }
        loadOptions={searchProperties}
        defaultOptions={propertyOptions}
      />
      {hasError && <InputFeedback>{formError}</InputFeedback>}
    </InputGroup>
  );
}

PropertyField.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  label: PropTypes.string,
  mb: PropTypes.any,
  allowRequestProperty: PropTypes.bool
};

export default PropertyField;
